<template>
  <v-container>

    <v-row>
      <v-col cols="12" md="6">
        <div class="headline">
          Direct Payments: ${{userProfile.directPaymentsTotal}}
        </div>
        <div class="headline">
          Commissions Payments: ${{userProfile.comPaymentsTotal}}
        </div>
        <v-row>
          <v-col cols="12">

          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn color="primary" large block @click="createLink">
              <v-icon color="white" class="mr-2">fab fa-cc-stripe</v-icon>launch dashboard<v-progress-circular indeterminate v-if="(userProfile.balances || false).waitingForUrl || false" class="pl-2"></v-progress-circular>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <div v-if="userPayments.length !== 0">
          <template>
            <payout-list-item :key="item._key" v-for="item in userPayments" :transaction="item" ></payout-list-item>
          </template>
        </div>
        <v-row v-else>
          <v-col cols="12" align="center">
            <div >{{ $language.transactions['There are no transactions at the moment'] }}.</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show" :color="snackbar.status === 'error' ? 'error' : 'success'" multi-line :timeout="1500">
      {{ snackbar.message }}

    </v-snackbar>

  </v-container>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import PayoutListItem from '@/components/jefe/payouts/PayoutListItem'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    PayoutListItem
  },
  data () {
    return {
      buttonLoading: false,
      ratingDialog: false,
      rating: {
        comment: '',
        rating: null,
        ratingDate: new Date()
      },
      jobId: null,
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      }
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser', 'userPayments']),

    url () {
      if (this.userProfile.balances) {
        return this.userProfile.balances.url
      }
      return null
    }
  },
  methods: {
    createLink () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/balances/getNewURL`] = new Date()
      updates[`user/${this.currentUser.uid}/profile/balances/waitingForUrl`] = true
      fb.database.ref().update(updates)
    },
    handleRateIndividual (transaction) {
      this.ratingProfileId = transaction.senderId
      this.jobId = transaction._key
      this.ratingDialog = true
    },
    async rate () {
      this.buttonLoading = true
      var updates = {}
      this.rating.ratedByName = this.userProfile.public.name
      this.rating.ratedById = this.currentUser.uid
      updates[`/user/${this.ratingProfileId}/profile/public/ratings/${this.jobId}`] = this.rating
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.ratingDialog = false
      this.rating.comment = ''
      this.rating.rating = null
      this.snackbar.message = this.$language.jobDetails['Review submitted']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    }
  },
  watch: {
    url () {
      if (this.userProfile.balances.waitingForUrl === false) {
        window.location.href = this.url
      }
      // var updates = {}
      // updates[`user/${this.currentUser.uid}/profile/balances/waitingForUrl`] = null
      // fb.database.ref().update(updates)
    }

  },
  filters: {
    formatMonth (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      // There's most definitely a more elegant way of doing this.
      return moment(date).format('MMM')
    },
    formatDay (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      // There's most definitely a more elegant way of doing this.
      return moment(date).format('D')
    },
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 10) {
        return val
      }
      return `${val.substring(0, 10)}...`
    }
  }
}
</script>
